import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=583fa4bd&shadow"
import script from "./PortalHeader.vue?vue&type=script&lang=js&shadow"
export * from "./PortalHeader.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./PortalHeader.vue?vue&type=style&index=0&id=583fa4bd&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports